export default function MidCTA() {
  return (
    <section className="relative overflow-hidden py-24">
      <div className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('https://public.readdy.ai/ai/img_res/ddfdf14ab484c06288e247e4a498b586.jpg')" }} />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/95 via-[#050505]/85 to-[#050505]/60" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 bg-[#FF6B35]/20 border border-[#FF6B35]/40 text-[#FF6B35] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-shield-fill text-xs" /></span>
            Protect Your Investment
          </span>
          <h2 className="font-display font-black text-4xl lg:text-6xl text-white leading-tight mb-4">
            Every Drive, Every Day —<br />
            <span className="text-[#FF6B35]">Your Paint, Protected.</span>
          </h2>
          <p className="text-white/70 text-lg max-w-xl mb-10">
            A rock chip can happen in an instant. PPF and ceramic coating from DBN Garage means you never have to worry about it. Get a free consultation today.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a href="#lead-form"
              className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold text-base px-8 py-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-check-fill" /></span>
              Book Free Consultation
            </a>
            <a href="tel:+18605550127"
              className="flex items-center gap-2 border border-white/30 hover:border-white/60 text-white font-bold text-base px-8 py-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill" /></span>
              (860) 555-0127
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
